import { Component, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { NewsItem } from '../../../services/news-items/news-items';
import { NewsItemsService } from '../../../services/news-items/news-items.service';
import { NewsDialogComponent } from '../news-dialog/news-dialog.component';

@Component({
  selector: 'app-news-item-card',
  standalone: true,
  imports: [CommonModule, MatIconModule, MatDialogModule],
  templateUrl: './news-item-card.component.html',
  styleUrl: './news-item-card.component.css',
})
export class NewsItemCardComponent implements OnInit {
  @Input() newsItem!: NewsItem;
  @Input() compact: boolean = false;
  @Input() hideMetadata: boolean = false;

  thumbnailUrl: string | undefined;

  constructor(
    private dialog: MatDialog,
    private sanitizer: DomSanitizer,
    private newsItemsService: NewsItemsService,
  ) {}

  ngOnInit(): void {
    if (this.newsItem.thumbnailDocumentId) {
      this.newsItemsService.resolveDocumentUrl(this.newsItem.thumbnailDocumentId).subscribe(url => {
        this.thumbnailUrl = url;
      });
    } else {
      this.thumbnailUrl = this.newsItem.thumbnailSrc;
    }
  }

  openContent(): void {
    if (!this.newsItem.contentSrc && !this.newsItem.contentDocumentId) return;

    if (this.newsItem.contentDocumentId) {
      this.newsItemsService.resolveContentDocument(this.newsItem.contentDocumentId).subscribe(result => {
        if (!result) return;
        if (result.mimeType.startsWith('image/')) {
          this.dialog.open(NewsDialogComponent, {
            width: '700px',
            maxHeight: '90vh',
            data: { title: this.newsItem.title, isImage: true, imageUrl: result.url },
          });
        } else {
          const safeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(result.url + '#toolbar=0&navpanes=0');
          this.dialog.open(NewsDialogComponent, {
            width: '700px',
            maxHeight: '90vh',
            data: { title: this.newsItem.title, isImage: false, embedUrl: safeUrl },
          });
        }
      });
      return;
    }

    const src = this.newsItem.contentSrc ?? '';
    const safeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(src);
    this.dialog.open(NewsDialogComponent, {
      width: '700px',
      maxHeight: '90vh',
      data: { title: this.newsItem.title, isImage: false, embedUrl: safeUrl },
    });
  }
}
